/**
 * Executes an array of async task factories with a bounded concurrency pool.
 * Preserves result order relative to the input task array.
 *
 * @template T
 * @param {Array<() => Promise<T>>} tasks
 * @param {number} concurrency
 * @returns {Promise<T[]>}
 */
export const runWithConcurrency = async (tasks, concurrency) => {
  if (!Array.isArray(tasks) || tasks.length === 0) {
    return [];
  }

  const safeConcurrency = Math.max(1, Math.min(concurrency, tasks.length));
  const results = new Array(tasks.length);
  let nextTaskIndex = 0;

  const worker = async () => {
    while (nextTaskIndex < tasks.length) {
      const taskIndex = nextTaskIndex;
      nextTaskIndex += 1;
      results[taskIndex] = await tasks[taskIndex]();
    }
  };

  await Promise.all(Array.from({ length: safeConcurrency }, worker));
  return results;
};
